import debug from 'debug';
import BaseComponent from 'Global/Shared/Components/BaseComponent/BaseComponent';

const log = debug('ProductPagesTeaser');

class ProductPagesTeaser extends BaseComponent {
	constructor(element) {
		super(element);

		this.toggleEvent = this.toggleHandler.bind(this);

		this.initialize();
	}

	eventListeners() {
		this.dom.toggleButton.addEventListener('click', this.toggleEvent, false);
	}

	headline() {
		const headlineElement = this.dom.text.querySelector('h1');
		if (headlineElement === null || this.dom.iconWrapper === undefined) return;

		headlineElement.insertAdjacentElement('afterbegin', this.dom.iconWrapper);
	}

	initialize() {
		this.initDomCache();
		this.setup();
		this.eventListeners();
	}

	setup() {
		this.headline();

		log('setup() - expanded text, children', this.dom.expandedText, this.dom.expandedText.children.length)
		if (this.dom.expandedText.children.length > 0) {
			this.dom.toggleButton.classList.add('is-visible');
		}
	}

	toggleHandler() {
		this.element.classList.toggle('is-expanded');
	}

}

export default ProductPagesTeaser;
